/***
 * 小程序的统一配置
 * 不同开发环境配置
 * @fjf
 */
import xcx from './xcx-config.js';
import wxBridge from '@/utils/wx-bridge.js';
// let env = "dev56";//小白
// let env = "dev20";//禄堂
// let env = "dev27";//方迪生
let env = "test";//测试库
// let env = "prod";//正式库
// #ifdef H5
if (wxBridge.getStorageSync('port')) {
  env = wxBridge.getStorageSync('port')
}
// #endif
let config = {
  ...xcx
};

switch (env) {
  //api的配置
  case "dev56":
    config = {
      headUrl: ``,
      apiUrl: 'http://192.168.168.56:8881',//小白
      ...config
    }
    break;
  case "dev20":
    config = {
      headUrl: ``,
      apiUrl: 'http://192.168.168.20:8881',//禄堂
      ...config
    }
    break;
  case "dev27":
    config = {
      headUrl: ``,
      apiUrl: 'http://192.168.168.27:8881',//方迪生
      ...config
    }
    break;
  case "test":
    config = {
      headUrl: ``,
      apiUrl: 'http://192.168.0.91:8881',//测试库
      ...config
    }
    break;
  case "prod":
    config = {
      headUrl: ``,
      apiUrl: 'https://elder.zykj.com/prod-api',//正式库
      ...config
    }
    break;
}
// #ifdef H5
console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'development') {
} else {
  const currentDomain = window.location.hostname; // 获取当前域名
  if (currentDomain.indexOf('test') != -1) {
    env = "test"
  } else {
    env = "prod"
  }
}
config.ApiEncrypt = true
config.apiUrl = `/${env}-api`
// #endif

export default config
